import { render, staticRenderFns } from "./AddMarket.vue?vue&type=template&id=61d0c00f&scoped=true"
import script from "./AddMarket.vue?vue&type=script&lang=js"
export * from "./AddMarket.vue?vue&type=script&lang=js"
import style0 from "./AddMarket.vue?vue&type=style&index=0&id=61d0c00f&prod&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d0c00f",
  null
  
)

export default component.exports